<div [ngClass]="{ 'container' : !(isMobile | async) }" [class.mx-4]="isMobile | async">
  <h1 class="sr-only">Faculty Profile Search</h1>
  <!-- Filters -->
  <div class="row rounded p-3 mb-3 mt-3 bg-white shadow-sm" id="top">
    <div class="col-md-4">
      <form class="search-form">
        <div class="form-group has-search">
          <fa-icon [icon]="faSearch" class="form-control-feedback"></fa-icon>
          <input type="text" class="form-control" placeholder="Profile Search" autocomplete="false"
            [formControl]="searchField" autocomplete="off" [ngbTypeahead]="autoComplete"
            [resultFormatter]="autoCompleteFormatter" [inputFormatter]="autoCompleteFormatter"
            (selectItem)="search(false, false, $event.item)" (keyup.enter)="search(false, false, searchField.value)"
            aria-label="Profile search">
        </div>
      </form>
    </div>
    <div class="col-md-8 d-flex" [ngClass]="!(isMobile | async) ? 'align-items-center' :  'flex-column'">
      <div class="form-group row filter-group w-100">
        <div class="col-12 col-md-6 mb-2 mb-md-0">
          <select class="form-control w-100" (change)="search(false, true, $event.target.value)"
            aria-label="Filter by school">
            <option class="text-muted disabled" value="">School</option>
            <ng-container *ngFor="let school of (directoryFilter | async)?.schools">
              <option class="truncate-label" [value]="school">{{ school }}</option>
            </ng-container>
          </select>
        </div>
        <div class="col-12 col-md-6">
          <select class="form-control w-100" (change)="search(true, false, $event.target.value)"
            aria-label="Filter by department">
            <option class="text-muted disabled" value="">Department</option>
            <ng-container *ngFor="let dept of getAvailableDepartments()">
              <option class="truncate-label" [value]="dept">{{ dept }}</option>
            </ng-container>
          </select>
        </div>
      </div>
    </div>
    <div class="ml-3" *ngIf="appliedFilter | async as filter" [ngClass]="{ 'mt-3' : isMobile | async }">
      <button class="badge badge-pill badge-info badge-filter w-100 w-md-auto" (click)="clearFilter()"
        [attr.aria-label]="'Clear filter: ' + filter">
        <span class="badge-text">{{ filter }}</span>
        <fa-icon [icon]="faTimes" class="ml-3" aria-hidden="true"></fa-icon>
      </button>
    </div>
  </div>
  <!-- Filters -->
  <!-- Listing -->
  <ng-container *ngIf="!isLoading">
    <div *ngFor="let item of directory | async | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize;"
      class="row rounded p-3 mb-3 mt-3 listing-item shadow-sm" style="background-color: #fff;">
      <app-listing class="w-100" [listing]="item"></app-listing>
    </div>
  </ng-container>

  <ng-container *ngIf="isLoading">
    <div *ngFor="let num of skeletonLoaders" class="row rounded p-3 mb-3 mt-3 listing-item shadow-sm"
      style="background-color: #fff;">
      <div class="col-md-2">
        <ngx-skeleton-loader count="1" appearance="circle" [theme]="{
          width: '100px',
          height: '150px',
          'border-radius': '4px'
        }">
        </ngx-skeleton-loader>
      </div>
      <div class="col-md-4">
        <ngx-skeleton-loader count="5"></ngx-skeleton-loader>
      </div>
    </div>
  </ng-container>
  <!-- Listing -->
  <!-- Pagination -->
  <div class="row mt-3">
    <div class="col-md-12 d-flex justify-content-end">
      <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="(directory | async)?.length"
        [directionLinks]="false" [boundaryLinks]="true" [maxSize]="5" [rotate]="true" [ellipses]="false">
      </ngb-pagination>
    </div>
  </div>
  <!-- Pagination -->
</div>